/** The KoalaSpot mark: a koala in an appointment book (a calendar with two rings on top). */
export function KoalaMark({ className = 'size-6', title }: { className?: string; title?: string }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
      <rect x="13" y="3" width="38" height="16" rx="6" fill="#d6bf8c" />
      <circle cx="24" cy="10" r="2.2" fill="#fbf8ef" />
      <circle cx="40" cy="10" r="2.2" fill="#fbf8ef" />
      <rect x="7" y="14" width="50" height="46" rx="12" fill="#026853" />
      <path d="M7 26c0-6.6 5.4-12 12-12h26c6.6 0 12 5.4 12 12v6H7z" fill="#035441" />
      <circle cx="21" cy="31" r="8" fill="#f5e4b8" />
      <circle cx="43" cy="31" r="8" fill="#f5e4b8" />
      <ellipse cx="32" cy="40" rx="13.5" ry="12" fill="#f5e4b8" />
      <ellipse cx="32" cy="42" rx="4.2" ry="5.6" fill="#02352a" />
      <path d="M23.5 38.5a2.6 2.6 0 0 1 5 0M35.5 38.5a2.6 2.6 0 0 1 5 0" fill="none" stroke="#02352a" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
